<template>
    <div>

    	<div class="stores mb-5">

			<h3 class="mb-4">Meine Studios</h3>

			<table class="table">
			  <thead class="thead-dark">
			    <tr>
			      <th scope="col">Name</th>
			      <th scope="col">Adresse</th>
			      <th scope="col">PLZ</th>
			      <th scope="col">Ort</th>
			      <th scope="col"></th>
			    </tr>
			  </thead>
			  <tbody>
			  	<tr v-for="store in stores">
					<td><a :href="'stores/' + store.id">{{ store.name }}</a></td>
					<td>{{ store.address }}</td>
					<td>{{ store.zip }}</td>
					<td>{{ store.city }}</td>
					<td>
						<a href="javascript:void(0);"><i class="fa fa-trash" aria-hidden="true" @click="deleteStore(store.id)"></i></a> 
					</td>
				</tr>
			  </tbody>
			</table>

		</div>

		<button type="button" class="btn btn-primary" v-on:click="hideNewStoreContainer = false" v-if="hideNewStoreContainer">Neues Studio anlegen</button>

		<div class="new-store" v-if="!hideNewStoreContainer">

	        <h3 class="mb-4">Neues Studio anlegen:</h3>

	        <div class="card p-3">

				<form role="form">

					<div class="form-group">
						<label>Studio Name</label>
						<input type="text" v-model="newstore.name" class="form-control" placeholder="Name des Studios">
					</div>

					<div class="form-group">
						<label>E-Mail</label>
						<input type="email" v-model="newstore.email" class="form-control" placeholder="E-Mail Adresse des Studios">
					</div>

					<div class="form-group">
						<label>Adresse</label>
						<input type="text" v-model="newstore.address" class="form-control" placeholder="z.B. Musterstr. 3">
					</div>

					<div class="form-group">
						<label>Postleitzahl</label>
						<input type="text" v-model="newstore.zip" class="form-control" placeholder="z.B. 80807">
					</div>

					<div class="form-group">
						<label>Ort</label>
						<input type="text" v-model="newstore.city" class="form-control" placeholder="z.B. München">
					</div>

					<div class="form-group">
						<label>Land</label>
						<input type="text" v-model="newstore.country" class="form-control" placeholder="z.B. Deutschland">
					</div>

					<h5>Öffnungszeiten</h5>

					<div class="form-group">
						<div class="row">
							<div class="col">
								<label>Montag von</label>
								<input v-model="newstore.mon_from" type="text" class="form-control" placeholder="0800">
							</div>
							<div class="col">
								<label>Montag bis</label>
								<input v-model="newstore.mon_until" type="text"  class="form-control" placeholder="1800">
							</div>
						</div>
						<div class="form-check">
							<input type="checkbox" class="form-check-input" idx="monClosed">
							<label class="form-check-label" v-model="newstore.mon_closed" for="monClosed">Montag geschlossen</label>
						</div>
					</div>

					<div class="form-group">
						<div class="row">
							<div class="col">
								<label>Dienstag von</label>
								<input type="text" v-model="newstore.tue_from" class="form-control" placeholder="0800">
							</div>
							<div class="col">
								<label>Dienstag bis</label>
								<input type="text" v-model="newstore.tue_until" class="form-control" placeholder="1800">
							</div>
						</div>
						<div class="form-check">
							<input type="checkbox" class="form-check-input" id="tueClosed">
							<label class="form-check-label" v-model="newstore.tue_closed" for="tueClosed">Dienstag geschlossen</label>
						</div>
					</div>

					<div class="form-group">
						<div class="row">
							<div class="col">
								<label>Mittwoch von</label>
								<input type="text" v-model="newstore.wed_from" class="form-control" placeholder="0800">
							</div>
							<div class="col">
								<label>Mittwoch bis</label>
								<input type="text" v-model="newstore.wed_until" class="form-control" placeholder="1800">
							</div>
						</div>
						<div class="form-check">
							<input type="checkbox" class="form-check-input" id="wedClosed">
							<label class="form-check-label" v-model="newstore.wed_closed" for="wedClosed">Mittwoch geschlossen</label>
						</div>
					</div>

					<div class="form-group">
						<div class="row">
							<div class="col">
								<label>Donnerstag von</label>
								<input type="text" v-model="newstore.thu_from" class="form-control" placeholder="0800">
							</div>
							<div class="col">
								<label>Donnerstag bis</label>
								<input type="text" v-model="newstore.thu_until" class="form-control" placeholder="1800">
							</div>
						</div>
						<div class="form-check">
							<input type="checkbox" class="form-check-input" id="thuClosed">
							<label class="form-check-label" v-model="newstore.thu_closed" for="thuClosed">Donnerstag geschlossen</label>
						</div>
					</div>

					<div class="form-group">
						<div class="row">
							<div class="col">
								<label>Freitag von</label>
								<input type="text" v-model="newstore.fri_from" class="form-control" placeholder="0800">
							</div>
							<div class="col">
								<label>Freitag bis</label>
								<input type="text" v-model="newstore.fri_until" class="form-control" placeholder="1800">
							</div>
						</div>
						<div class="form-check">
							<input type="checkbox" class="form-check-input" id="friClosed">
							<label class="form-check-label" v-model="newstore.fri_closed" for="friClosed">Freitag geschlossen</label>
						</div>
					</div>

					<div class="form-group">
						<div class="row">
							<div class="col">
								<label>Samstag von</label>
								<input type="text" v-model="newstore.sat_from" class="form-control" placeholder="0800">
							</div>
							<div class="col">
								<label>Samstag bis</label>
								<input type="text" v-model="newstore.sat_until" class="form-control" placeholder="1800">
							</div>
						</div>
						<div class="form-check">
							<input type="checkbox" class="form-check-input" id="satClosed">
							<label class="form-check-label" v-model="newstore.sat_closed" for="satClosed">Samstag geschlossen</label>
						</div>
					</div>

					<div class="form-group">
						<div class="row">
							<div class="col">
								<label>Sonntag von</label>
								<input type="text" v-model="newstore.sun_from" class="form-control" placeholder="0800">
							</div>
							<div class="col">
								<label>Sonntag bis</label>
								<input type="text" v-model="newstore.sun_until" class="form-control" placeholder="1800">
							</div>
						</div>
						<div class="form-check">
							<input type="checkbox" class="form-check-input" id="sunClosed">
							<label class="form-check-label" v-model="newstore.sun_closed" for="sunClosed">Sonntag geschlossen</label>
						</div>
					</div>

				  	<button type="button" class="btn btn-primary" @click="saveStore">Neues Studio speichern</button>

				</form>

			</div>

		</div>

    </div>
</template>

<script>
    export default {

    	data() {
            return {
				newstore: {
					name: '',
					email: '',
					address: '',
					zip: '',
					city: '',
					country: '',
					mon_from: '',
					mon_until: '',
					tue_from: '',
					tue_until: '',
					wed_from: '',
					wed_until: '',
					thu_from: '',
					thu_until: '',
					fri_from: '',
					fri_until: '',
					sat_until: '',
					sat_from: '',
					sun_until: '',
					sun_from: '',
					mon_closed: '',
					tue_closed: '',
					wed_closed: '',
					thu_closed: '',
					fri_closed: '',
					sat_closed: '',
					sun_closed: '',
					google_calendar_id: '',
					logo_filename: '',
					user_id: '',
				},
				stores: [],
				hideNewStoreContainer: true
            };
        },

        mounted() {
			console.log('Component mounted.');
			console.log(this.storedata);
			this.stores = JSON.parse(this.storedata);
        },

        methods: {

            saveStore() {

                var _this = this;

				axios.post('/stores', this.$data.newstore)
				.then(function (response) {
				    console.log(response);
				    if(response.status == 200) {
				    	//_this.stores.push( this.$data.newstore );
				    	location.reload();
				    }
				})
				.catch((error) => {
				    if (error.response) {
				        console.log(error.response.data.errors);
				        alert(error.response.data.errors);
				        //_this.errors = error.response.data.errors;
				    }
				}); 

            },

            deleteStore(id) {
				var r = confirm("Wollen Sie das Studio wirklich löschen?");
				if (r == true) {

					axios.delete('/stores/'+id)
					.then(function (response) {
					    console.log(response);
					    if(response.status == 200) {
					    	//_this.stores.push( this.$data.newstore );
					    	location.reload();
					    }
					})
					.catch((error) => {
					    if (error.response) {
					        console.log(error.response.data.errors);
					        alert(error.response.data.errors);
					        //_this.errors = error.response.data.errors;
					    }
					});

					// update data
					//console.log(this.stores);

				} else {
					return;
				}
            },

            editStore(id) {
            	this.hideNewStoreContainer = false;
            	/*this.stores.forEach(function(store) {
            		if(store.id == id) {
            			// store found in data
            			this.newstore.name = store.name;
            		}

            	});*/
            }

        },
		props: {
			storedata: {
				type: String
			}
		},

    }
</script>
